import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { MdAccountBalanceWallet } from "react-icons/md";
import { Helmet } from "react-helmet";
import queryString from "app/services/queryStringService";
import _ from "lodash";

import { getApiUserGroup } from "app/services/MasterAdmin & ApiUSer/apiUserGroupService";

import EditUserGroup from "./EditApiGroup";
import EditApiGroup from "./EditApiGroup";

const ApiGroupList = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [userGroupId, setUserGroupId] = useState(null);

  const dateFormatter = (row) => {
    return row.split("T")[0];
  };
  const openCommissionPopup = (id) => {
    setUserGroupId(id);
  };
  const actionFormatter = (cell, row) => {
    if ((row.status = "Pending")) {
      return (
        <>
          <DropdownButton variant="outline-primary" title="Action" size="sm">
            <Dropdown.Item
              data-bs-toggle="modal"
              data-bs-target="#commission"
              onClick={() => openCommissionPopup(row.id)}
            >
              <MdAccountBalanceWallet className="text-primary mr-4"></MdAccountBalanceWallet>
              Tag API Partner Commission
            </Dropdown.Item>
          </DropdownButton>
        </>
      );
    }
  };

  const editFormatter = (cell, row) => {
    return <EditUserGroup refresh={loadUserGroup} data={row} />;
  };

  const columns = [
    {
      dataField: "name",
      text: "Name",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "validTo",
      text: "Valid To",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "id",
      text: "Edit",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: editFormatter,
    },
    {
      dataField: "modifiedOn",
      text: "Tag Markup",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const loadUserGroup = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    try {
      const response = await getApiUserGroup(query);
      const responseData = response.data.data;

      const paggingData = JSON.parse(response.headers["x-pagination"]);

      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUserGroup();
  }, [page, sizePerPage]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <div className="d-flex flex-row-reverse">
        <EditApiGroup type="addUser" refresh={loadUserGroup} />
      </div>
      <Helmet>
        <title>API Markup Group List</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "API Markup Group List" }]}
      ></Breadcrumb>

      <div>
        <BootstrapTable
          hover
          remote
          keyField="id"
          data={data}
          columns={columns}
          pagination={paginationFactory(paginationOptions)}
          onTableChange={handleTableChange}
          noDataIndication={() => <NoDataIndication />}
          headerClasses="bg-primary text-white"
          bodyClasses="react-bootstrap-table-next-min-height"
          rowStyle={rowStyle}
        />
      </div>
    </>
  );
};

export default ApiGroupList;
